import { render, staticRenderFns } from "./SubUnitList.vue?vue&type=template&id=219f22b0&scoped=true&"
import script from "./SubUnitList.vue?vue&type=script&lang=ts&"
export * from "./SubUnitList.vue?vue&type=script&lang=ts&"
import style0 from "./SubUnitList.vue?vue&type=style&index=0&id=219f22b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219f22b0",
  null
  
)

export default component.exports